import http from '@/common/http'
// 获取历史消息
export function historyList(data) {
    return http.get({
        url: process.env.VUE_APP_BASE_URL +  '/thomasChatServer/server/session/history',
        // url: '/server/session/history',
        params: data,
        // successCallback: (responseData) => {
        //   // 处理成功的返回数据
        //   console.log(responseData);
        // },
        // failCallback: (errorData) => {
        //   // 处理错误的返回数据
        //   console.error(errorData);
        // }
    })
  }

//   新增评价
export function evaluation(data) {
    return http.post({
        url:  process.env.VUE_APP_BASE_URL +  '/thomasChatServer/server/evaluation',
        // url:  '/server/evaluation',
        params: data
    })
 }
// 上传图片
export function uploadImg(data) {
    return http.uploadFile({
        url:  process.env.VUE_APP_BASE_URL +  '/thomasChatServer/server/upload/file',
        // url:  '/server/upload/file',
        params: data
    })
 }

//  分配客服
export function assignCS(data) {
    return http.post({
        url:  process.env.VUE_APP_BASE_URL +  '/thomasChatServer/server/session/assignCS',
        // url:  '/server/session/assignCS',
        params: data
    })
 }